// extracted by mini-css-extract-plugin
module.exports = {"dev_body":"CrossPost_dev_body__39B28","dev_body_secondary":"CrossPost_dev_body_secondary__IbpJo"};